module.exports = __webpack_public_path__ + "img/file-arrow-down-solid.1aff5672.svg";